import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';

interface EditorFooterProps {
  isDirty: boolean;
  onSave: () => void;
  saving: boolean;
  isSystemPrompt: boolean;
}

export function EditorFooter({
  isDirty,
  onSave,
  saving,
  isSystemPrompt,
}: EditorFooterProps) {
  if (isSystemPrompt) {
    return null;
  }

  return (
    <Stack
      direction="row"
      pt={1}
      spacing={1}
      alignItems="center"
      justifyContent="flex-end"
      borderTop="1px solid"
      borderColor="divider"
    >
      <Button
        size="sm"
        variant="primary"
        onClick={onSave}
        loading={saving}
        disabled={!isDirty}
      >
        Save changes
      </Button>
    </Stack>
  );
}
